/**
 * Espelha venda_tipo_integracao (db_vendas) e VendaTipoIntegracaoEnum (API Vendas e OrquestradorVendas): com qual
 * módulo a venda troca efeito. Existir linha do tipo em venda_integracao = lançado.
 */
export enum VendaTipoIntegracaoEnum {
    /** Financeiro: contas a receber do documento. */
    Financeiro = 1,
    /** Estoque: movimentação de estoque do documento. */
    Estoque = 2,
    NFe = 3,
    NFCe = 4,
    NFSe = 5,
    /** Financeiro (movimentação): movimentações diretas de caixa/banco do documento. Mesmo indicador F. */
    FinanceiroMovimentacao = 6,
}

/**
 * Sigla, nome e cor do indicador de cada tipo de integração. A cor é a variável global da paleta
 * de siglas, pronta para `[style.--indicador-cor]`.
 */
export const VendaTipoIntegracaoIndicador: { [key: number]: { sigla: string; nome: string; cor: string } } = {
    [VendaTipoIntegracaoEnum.Financeiro]: { sigla: 'F', nome: 'Financeiro', cor: 'var(--indicador-cor-f)' },
    [VendaTipoIntegracaoEnum.Estoque]: { sigla: 'E', nome: 'Estoque', cor: 'var(--indicador-cor-e)' },
    [VendaTipoIntegracaoEnum.NFe]: { sigla: 'NS', nome: 'NF-e', cor: 'var(--indicador-cor-ns)' },
    [VendaTipoIntegracaoEnum.NFCe]: { sigla: 'NC', nome: 'NFC-e', cor: 'var(--indicador-cor-nc)' },
    [VendaTipoIntegracaoEnum.NFSe]: { sigla: 'NFS', nome: 'NFS-e', cor: 'var(--indicador-cor-nfs)' },
    [VendaTipoIntegracaoEnum.FinanceiroMovimentacao]: { sigla: 'F', nome: 'Financeiro', cor: 'var(--indicador-cor-f)' },
};
